import React, { useContext } from 'react';
import { Watermark } from '@mummssoftware/common-ui';
import { PatientsListingContext } from '../../context';
import { PatientsListingTable } from './PatientsListingTable';
import { Container } from '../../components/layout/WrapperDiv';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

type PatientsListingProps = {
  currentUser: mumms.User;
  patientsList: mumms.patient[];
  appTitle?: string;
  smallWidget?: boolean;
} & typeof RouteProps;

export const PatientsListingComponent = ({
  smallWidget,
}: PatientsListingProps) => {
  const { watermark } = useContext(PatientsListingContext);

  return (
    <Container id="patients-listing-container">
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <PatientsListingTable smallWidget={smallWidget} />
    </Container>
  );
};

export default PatientsListingComponent;
